module.exports = __webpack_public_path__ + "ea71d6739e496194a42f9e2a443c17a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Johannesdottir.jpg
// module id = uaNr
// module chunks = 0